import React, { useContext } from "react";
import "./DatePicker.css";
import { ThemeContext } from "../../../../..";

const DatePickerConditional = ({
  label = "",
  name = "",
  minDate = null,
  maxDate = null,
  register = () => {},
  errors = null,
  mandatory = false,
  defaultDateValue = null,
  applyTableCustomClass = false,
  setDatePicked = () => {},
  style = {},
  setDate = () => {},
  disabled,
  value,
  onChange,
  className
}) => {
  const handleDateChange = (event) => {
    const date = event.target.value;
    setDatePicked(date);
    setDate(date);
    if (onChange) {
      onChange(date);
    }
  };
  const { theme } = useContext(ThemeContext);
  // Add CSS to fix the date picker styling
  const datePickerStyles = {
    ...style,
    colorScheme: 'white', // Force dark mode for the date picker
    // Override text color to ensure date parts are visible
    color: 'white',
    opacity: 1
  };
  
  const cssOverrides = `
  /* Override the native date picker styles */
  input[type="date"]::-webkit-calendar-picker-indicator {
    filter: invert(50%) sepia(30%) saturate(1352%) hue-rotate(123deg) brightness(95%) contrast(82%);
    opacity: 1;
  }
  
  input[type="date"]::-webkit-datetime-edit-fields-wrapper {
    color: ${theme === 'light' ? "#2b6591" : "white"} !important;
    opacity: 1 !important;
  }
  
  input[type="date"]::-webkit-datetime-edit-year-field,
  input[type="date"]::-webkit-datetime-edit-month-field,
  input[type="date"]::-webkit-datetime-edit-day-field {
    color: ${theme === 'light' ? "#2b6591" : "white"} !important;
    opacity: 1 !important;
  }
`;
  
  return (
    <div className="date__container">
      {/* Inject the CSS overrides */}
      <style>{cssOverrides}</style>
      
      {label && (
        <label className="datepicker__label" htmlFor={name}>
          {label}
          {mandatory && <span className="asterisk">*</span>}
        </label>
      )}
      <div>
        <input
          type="date"
          min={minDate}
          max={maxDate}
          disabled={disabled}
          style={datePickerStyles}
          className={`date_picker_control form-control 
          ${disabled && "disabled__field"}
          ${applyTableCustomClass ? "custom-form-control" : ""} ${
            errors && errors[name] ? "error__border--color" : "form__input"
          } ${className || ""}`}
          id={name}
          name={name}
          defaultValue={defaultDateValue}
          value={value || ''}
          {...register(name)}
          onChange={handleDateChange}
        />
        {errors && errors[name] && (
          <p className="error__message">{errors[name].message}</p>
        )}
      </div>
    </div>
  );
};

export default DatePickerConditional;